import { z } from 'zod';
import { paginationInput } from './common';

/** Uma escolha do companheiro: a pergunta e a alternativa marcada. */
export const respostaAptidaoSchema = z.object({
  perguntaId: z.string().uuid('Pergunta inválida'),
  alternativaId: z.string().uuid('Alternativa inválida'),
});

export const enviarRespostasInput = z.object({
  respostas: z
    .array(respostaAptidaoSchema)
    .min(1, 'Responda todas as perguntas antes de enviar')
    .max(50, 'Quantidade de respostas acima do esperado')
    .refine(
      (respostas) => new Set(respostas.map((r) => r.perguntaId)).size === respostas.length,
      'Há mais de uma resposta para a mesma pergunta'
    ),
});

export const listarResultadosInput = paginationInput.extend({
  diretoriaId: z.string().uuid().optional(),
  /** Quando false, traz também quem ainda não respondeu. */
  somenteRespondidos: z.boolean().default(false),
});

export const tentativaIdInput = z.object({
  tentativaId: z.string().uuid('Tentativa inválida'),
});

export type RespostaAptidao = z.infer<typeof respostaAptidaoSchema>;
export type EnviarRespostasInput = z.infer<typeof enviarRespostasInput>;
export type ListarResultadosInput = z.infer<typeof listarResultadosInput>;
export type TentativaIdInput = z.infer<typeof tentativaIdInput>;
